<template>
  <v-btn v-if="icon" icon @click="excluirProdutos">
    <v-icon>mdi-delete</v-icon>
  </v-btn>

  <v-badge v-else color="white" overlap>
    <v-btn small color="red" dark @click="excluirProdutos">
      <v-icon size="18">mdi-delete</v-icon>
      <span class="ml-1">excluir</span>
    </v-btn>

    <template #badge>
      <span class="text-black font-11" v-text="produtos.length" />
    </template>
  </v-badge>
</template>

<script>
import {excluirProdutosSilenciados} from "@/api/compraPorProdutosGerais/NotificacaoBlackList";
import {logout} from "@/helpers";

export default {
  name: "ExcluirProdutoSilenciado",
  props: {
    produtos: Array,
    icon: Boolean
  },
  methods: {
    excluirProdutos() {
      const callback = prod => ({grupo: prod.id_grupo, filial: prod.filial || 0, produto: prod.idproduto});
      const produtos = this.produtos.map(callback);

      this.$store.dispatch('loading/addRequisicao',
        excluirProdutosSilenciados({produtos})
          .then(() => {
            this.$emit('update:delecao-produto', {});
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>

</style>
